import { PRODUCT, ADMIN } from "./constants";
import { http } from "./httpServices";

export function postCreateCategoryData(data: any) {
  return http.post(`${PRODUCT}`, data);
}
export function putUpdatedCategoryData(data: any, id: string | any) {
  return http.put(`${PRODUCT}/${id}`, data);
}
export function getCategoryDataFromId(id: string | any) {
  return http.get(`${PRODUCT}/${id}`);
}

export function fetchAllProducts(category: string, outletId: string | any) {
  let outletCategory = category === "winter" ? "lww_tickets" : category;
  return http.get(
    `${PRODUCT}${ADMIN}?category=${outletCategory}&outletId=${outletId}`
  );
}

export function fetchAllActiveProducts(category: string, outletId: string | any) {
  let outletCategory = category === "winter" ? "lww_tickets" : category;
  return http.get(
    `${PRODUCT}${ADMIN}?category=${outletCategory}&outletId=${outletId}&isActive=true`
  );
}